import React, { useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";

import ClaimsByManagementType from "./ClaimsByManagementType";
import ClaimsByStatus from "./ClaimsByStatus";
import StatusSummary from "./StatusSummary";
import MonthlyReplacementCarRequest from "./MonthlyReplacementCarRequest";

import {
    getClaimCountByStatus,
    getClaimCountByManagementType,
} from "../../store/action/claim";

import { makeStyles } from "@material-ui/core/styles";

import { hasAuthorities } from "../../utils/authoritiesUtils";
import PasswordChangeDialog from "../../components/PasswordChangeDialog";

/* -------------------------------------------------------------------------- */
/*                                   STYLES                                   */
/* -------------------------------------------------------------------------- */
const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        // overflowX: 'hidden',
        minHeight: "85vh"
    },
    chartsContainer: {
        margin: '5px 0',
        height: 'auto',
    },
    rowContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        gap: '10px',
        flexWrap: 'wrap',
    },
    chartBox: {
        flex: '1 1 calc(50% - 10px)',
        minWidth: '300px',
        height: 'auto',
    },
    fullWidthChartBox: {
        width: '100%',
        marginTop: '15px',
    }, tableCellSmall: {
        fontFamily: "Poppins",
        fontWeight: 600,
        fontSize: 14,
        lineHeight: "21px",
        color: "rgba(70, 78, 95, 1)",
        borderBottom: "1px solid  rgba(0, 0, 0, 0.08)",
    },
    paper: {
        width: "100%",
        borderRadius: "11px",
        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
    },
    tableWrapper: {
        padding: "40px",
    },
    tableHeadRows: {
        whiteSpace: "nowrap",
        fontFamily: "Poppins",
        fontWeight: 600,
        fontSize: 12,
        lineHeight: "18px",
        color: "rgba(181, 181, 195, 1)",
        border: 0,
        background: "rgba(243, 246, 249, 1)",
        padding: "1%",
    },

    tableSortLabel: {
        color: "rgba(32, 29, 35, 1)",
        fontFamily: "Inter",
        fontWeight: 400,
        fontSize: 12,
        lineHeight: "18px",
    },
    titre: {
        fontFamily: "Poppins",
        fontSize: 12,
        fontWeight: 600,
        color: "rgba(63, 66, 84, 1)",
    },
    titreLabel: {
        fontFamily: "Poppins",
        fontSize: 12,
        fontWeight: 400,
        color: "rgba(32, 18, 70, 1)",
    },
    tablePagination: {
        fontFamily: "Poppins",
        fontSize: "12px",
        fontWeight: 400,
        lineHeight: "18px",
        color: "rgba(32, 18, 70, 1)",
    },
    dateRangeContainer: {
        display: "flex",
        alignItems: "center",
        border: "0.61px solid rgba(226, 217, 239, 1)",
        background: "rgba(255, 255, 255, 1)",
        borderRadius: 5,
        padding: "5px 10px",
    },
    dateContainer: {
        border: "none",
        outline: "none",
        background: "rgba(255, 255, 255, 1)",
        borderRadius: 5,
        fontFamily: "Poppins",
        paddingLeft: "5px",
    },
    inputContainer: {
        border: '0.61px solid rgba(226, 217, 239, 1)',
        background: 'rgba(255, 255, 255, 1)',
        width: '234px',
        height: '30px',
        borderRadius: 5,
        marginLeft: '20px',
    },
    viewBtn: {
        width: "40px",
        height: "34px",
        borderRadius: "6px",
        backgroundColor: "rgba(240, 243, 199, 1)",
        border: 0,
        lineHeight: "18px",
        color: "rgba(187, 200, 8, 1)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    taskNameColumn: {
        width: "114px",
        height: "20px",
        gap: "0px",
        fontFamily: "Poppins",
        fontSize: "10.17px",
        fontWeight: 500,
        textAlign: "left",
        color: "rgba(187, 200, 8, 1)",
        whiteSpace: "nowrap",
        overflow: "hidden",
    },
    tableContent: {
        fontFamily: "Inter",
        fontSize: 14,
        fontWeight: 400,
        //lineHeight: 19.6,
        textAlign: "left",
        color: "rgba(32, 29, 35, 0.8)",
        paragraph: {
            lineHeight: "32.69px",
        },
    },
    sinistres: {
        fontFamily: "Poppins",
        fontSize: 14,
        fontWeight: 600,
        textAlign: "left",
        color: "rgba(70, 78, 95, 1)",
    },
    dropdownMenu: {
        position: "absolute",
        zIndex: 1,
        backgroundColor: "white",
        border: "0.61px solid rgba(226, 217, 239, 1)",
        //boxShadow: theme.shadows[5],
        marginRight: "110px",
        borderRadius: 6,
    },
    dropdownItem: {
        padding: theme.spacing(1),
        cursor: "pointer",
        "&:hover": {
            backgroundColor: theme.palette.action.hover,
        },
        color: "rgba(32, 18, 70, 1)",
        fontFamily: "Poppins",
        fontSize: "10px",
        fontWeight: 400,
        textAlign: "left",
    },
    naText: {
        color: "rgb(145, 145, 145)",
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    paperModal: {
        backgroundColor: "rgba(255, 255, 255, 1)",
        border: "none",
        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
        padding: theme.spacing(2, 4, 3),
        width: "459px",
        height: "175px",
    },
    modalTitle: {
        fontFamily: "Poppins",
        fontSize: "18px",
        fontWeight: 500,
        lineHeight: "21px",
        textAlign: "left",
        marginBottom: "16px",
    },
    // dialogTitle: {
    //   fontFamily: "Poppins",
    //   fontWeight: 500,
    //   fontSize: 15,
    //   color: "rgba(63, 66, 84, 1)",
    //   backgroundColor: "white",
    //   borderBottom: "1px solid #E5EAEE",
    // },
    line: {
        height: "2px",
        backgroundColor: "rgba(243, 246, 249, 1)",
        width: "100%",
        marginBottom: "16px",
    },
    selectModal: {
        width: "400px",
        height: "36px",
        borderRadius: "4px",
        border: "1px solid rgba(222, 222, 222, 1)",
    },
    CancelStyle: {
        marginLeft: "20px",
        width: "62px",
        height: "26px",
        color: "rgb(255, 54, 54)",
        backgroundColor: " rgb(255, 229, 229)",
        fontFamily: "Poppins",
        fontSize: "10.76px",
        fontWeight: 600,
        border: 0,
        cursor: "pointer",
    },
    ExportStyle: {
        border: "0.96px solid rgba(187, 200, 8, 1)",
        color: "rgba(187, 200, 8, 1)",
        width: "64px",
        height: "27px",
        fontFamily: "Poppins",
        fontSize: "12.76px",
        fontWeight: 400,
        lineHeight: "19.14px",
        background: "rgba(255, 255, 255, 1)",
        margin: "0 1rem",
        cursor: "pointer",
    },
    ajouterStyle: {
        marginLeft: "20px",
        width: "64px",
        height: "27px",
        backgroundColor: "rgba(187, 200, 8, 1)",
        color: "rgba(255, 255, 255, 1)",
        borderRadius: "5.38px",
        fontFamily: "Poppins",
        fontSize: "10.76px",
        fontWeight: 600,
        border: 0,
        cursor: "pointer",
    },
    TextContainer: {
        display: "flex",
        justifyContent: "space-between",
        margin: "10px 15px",
    },
    dialogContent: {
        overflowY: "auto",
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
    },
    cardText: {
        fontFamily: "Poppins",
        fontSize: "13px",
        fontWeight: 400,
        color: "rgba(70, 78, 95, 1)",
    },
    cardValue: {
        fontFamily: "Poppins",
        fontSize: "13px",
        fontWeight: 500,
        color: "rgba(24, 28, 50, 1)",
        textAlign: "Right",
    },
    styleInput: {
        fontFamily: "Poppins",
        fontSize: "13px",
        fontWeight: 500,
        border: 0,
        background: "rgba(243, 246, 249, 1)",
        color: "rgba(24, 28, 50, 0.58)",
        lineHeight: "21px",
        padding: "5px",
        height: "36px",
        borderRadius: "4px",
    },
    card: {
        backgroundColor: "white",
        borderRadius: "8px",
        width: "100%",
        height: "680px",
        border: "0.61px solid rgba(226, 217, 239, 1)",
    },
    dialogPaper: {
        overflow: "hidden",
    },
    selectInput: {
        border: "0.61px solid rgba(226, 217, 239, 1)",
        background: "rgba(255, 255, 255, 1)",
        width: "148px",
        height: "29.69px",
        borderRadius: 5,
        marginLeft: "20px",
    },
    selectInputDialog: {
        width: "100%",
        border: "0",
        padding: "5px",
        background: "rgba(243, 246, 249, 1)",
        height: "29.69px",
        borderRadius: 5,
        alignItems: 'center', // Vertically center the text
        justifyContent: 'center', // Horizontally center the text

    },
    selectInputFiltre: {
        width: "100%",
        border: "0",
        height: "29.69px",
        borderRadius: 5,
        alignItems: 'center', // Vertically center the text
        justifyContent: 'center', // Horizontally center the text

    },
    optionLabel: {
        width: "150px",
        padding: theme.spacing(1),
        cursor: "pointer",
        "&:hover": {
            backgroundColor: theme.palette.action.hover,
        },
        color: "rgba(32, 18, 70, 1)",
        fontFamily: "Poppins",
        fontSize: "10px",
        fontWeight: 400,
        textAlign: "left",
    },
    dialogTitle: {
        fontFamily: "Poppins",
        fontWeight: 500,
        fontSize: 15,
        color: "rgba(63, 66, 84, 1)",
        backgroundColor: "white",
        borderBottom: "1px solid #E5EAEE",
    },
    autocompleteTag: {
        fontFamily: 'Poppins, sans-serif',
        backgroundColor: 'rgba(240, 243, 199, 1)',
        color: 'rgba(187, 200, 8, 1)',
        border: 'none',
        fontSize: '0.75rem',
        padding: '2px 6px',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '2px',
        borderRadius: '16px',
        display: 'inline-block',
        maxWidth: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    optionItem: {
        width: "100%",
        padding: theme.spacing(1),
        cursor: "pointer",
        backgroundColor: "white",
        color: "rgba(32, 18, 70, 1)",
        fontFamily: "Poppins",
        fontSize: "10px",
        fontWeight: 400,
        textAlign: "left",
        "&:hover": {
            backgroundColor: theme.palette.action.hover,
        },
        specialInput: {
            color: "rgba(24, 28, 50, 0.58)",
            fontFamily: "Poppins",
            fontSize: "13px",
            fontWeight: 500,
            textAlign: "right",
            backgroundColor: "rgba(243, 246, 249, 1)",
            border: "none",
            width: "209px",
            height: "28px",
        },

    },

}));

const Dashboard = () => {
    const dispatch = useDispatch();
    const classes = useStyles();



    const date = new Date();

    const {
        loading,
        claimsByStatus,
        claimsByManagementType,
    } = useSelector((state) => state.claimReducer);

    const passwordExpirationDateStr =
        localStorage.getItem("passwordExpirationDate");

    const passwordExpirationDate = passwordExpirationDateStr
        ? new Date(passwordExpirationDateStr)
        : null;

    const [open, setOpen] = useState(
        localStorage.getItem("updatedPassword") === "false" ||
        (passwordExpirationDate && date > passwordExpirationDate)
    );

    /* ----------------------------- FETCH STATS ----------------------------- */

    useEffect(() => {
        dispatch(getClaimCountByStatus());
        dispatch(getClaimCountByManagementType());
    }, [dispatch]);

    /* --------------------------- PASSWORD RULES ---------------------------- */

    return (
        <>
            <div className={classes.root}>
                <Box className={classes.chartsContainer}>
                    <StatusSummary
                        claimData={claimsByStatus}
                        loading={loading}
                    />
                </Box>

                <Box className={classes.rowContainer}>
                    <Box className={classes.chartBox}>
                        <ClaimsByManagementType
                            claimData={claimsByManagementType}
                            loading={loading}
                        />
                    </Box>

                    <Box className={classes.chartBox}>
                        <ClaimsByStatus
                            claimData={claimsByStatus}
                            loading={loading}
                        />
                    </Box>
                </Box>

                {hasAuthorities("VIEW_REPLACEMENT_CAR_REQUEST_MONTHLY") && (
                    <Box
                        className={`${classes.chartsContainer} ${classes.fullWidthChartBox}`}
                    >
                        <MonthlyReplacementCarRequest claimData={[]} />
                    </Box>
                )}
            </div>
            <PasswordChangeDialog open={open} onSuccess={() => { setOpen(false); if (!hasAuthorities("VIEW_DASHBOARD")) window.location.href = "/maeassurance/sinistres"; }} />
        </>
    );
};

export default Dashboard;
